import React from 'react';
import { LuGitBranch, LuCalendar } from "react-icons/lu";

const WorkflowCard = ({ 
  name, 
  createdAt, 
  onClick,
  icon = LuGitBranch,
  iconColor = "green-400"
}) => {
  const Icon = icon;
  
  const formatDate = (date) => {
    if (!date) return 'Unknown';
    const dateObj = date.toDate ? date.toDate() : new Date(date);
    return dateObj.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div
      onClick={onClick}
      className="p-4 h-48 bg-[#1e1e1e] hover:bg-[#2e2e2e] border border-[#ffffff10] rounded-xl flex flex-col justify-between cursor-pointer transition group"
    >
      <div className="flex space-x-3 items-start">
        <div className={`p-3 bg-${iconColor}/20 rounded-lg`}>
          <Icon className={`w-6 h-6 text-${iconColor}`} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-lg font-medium text-white truncate">{name}</div>
          <div className="text-sm text-[#ffffff50] mt-1">Workflow</div>
        </div>
      </div>
      <div className="flex space-x-3 items-center">
        <div className="p-3">
          <LuCalendar className="text-[#ffffff70] w-5 h-5" />
        </div>
        <div className="flex-1">
          <div className="text-sm text-[#ffffff50]">
            Created on {formatDate(createdAt)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowCard;